import React from "react";
import { useNavigate } from "react-router-dom";

import CustomButton from "components/common/Button";
import { getDaysUntilExpiry } from "components/Screens/Customers/utils";

import { WarningAmberOutlined as WarningIcon, ErrorOutlineOutlined as ErrorIcon } from "@mui/icons-material";

import "./PaymentExpiryBanner.scss";

function getPaymentExpiry({ expiry, warningDays }) {
  const result = getDaysUntilExpiry(expiry);

  if (!result || result.diffDays === null || !result.expiryDate) {
    return null;
  }

  const { diffDays } = result;

  if (diffDays <= warningDays) {
    if (diffDays < 0)
      return {
        message: "Your card has expired. Update your payment method now to avoid any payment issues.",
        expired: true,
      };

    return {
      message: "Your card is expiring soon. Update your payment method now to avoid any payment issues.",
      expirySoon: true,
    };
  }
  return null;
}

function PaymentExpiryBanner({ expiry, warningDays }) {
  const navigate = useNavigate();

  const result = getPaymentExpiry(expiry, warningDays);

  const { expirySoon, expired, message } = result || {};

  if (!expirySoon && !expired) {
    return null;
  }

  return (
    <div>
      {expirySoon && (
        <div className="payment-expiry-banner">
          <WarningIcon className="expiry-warning-icon" />
          <p className="para-body-m-regular color-text-warning ml-075 mr-1">{message}</p>
          <CustomButton
            label="Go to Payment Method"
            variant="text"
            color="warning"
            size="small"
            onClick={() => navigate("/main/payroll")}
          />
        </div>
      )}
      {expired && (
        <div className="payment-expired-banner">
          <ErrorIcon className="expired-warning-icon" />
          <p className="para-body-m-regular color-text-danger ml-075 mr-1">{message}</p>
          <CustomButton
            label="Go to Payment Method"
            variant="text"
            color="error"
            size="small"
            onClick={() => navigate("/main/payroll")}
          />
        </div>
      )}
    </div>
  );
}

export default PaymentExpiryBanner;
